<template>
  <div class="flex flex-col pbc-post-card" :id="'p' + id">
    <div class="flex flex-row flex-none">
    <!--
      <pbc-button @click='share'
                  class="self-center h-12 flex-none text-center text-xs rounded bg-gray-300 text-black">
        <comment-multiple-outline :size='16'/>
          <span>
            {{replies.total}}
        </span>
      </pbc-button>
      -->



      <div class="flex grow flex-col items-start ml-8 mb-2 mt-1">
        <user :user='user' class="text-white"/>
        <h2 class=" text-xs text-white font-bold">{{title}}</h2>
      </div>
    </div>

    <div class="grow overflow-hidden justify-center items-center flex" style='background-color: #313131'>
      <div style='height: 28rem; background-color: #313131'>
        <img :src='imageUrl'
              class="object-contain w-full h-full" />
      </div>
    </div>

    <main-bar :has-clips='false'
              @click-add="onAdd"
              @click-text="onText"
              @click-stickers="onStickers"
              @click-background="onBackground"
              @next='onRemix'
              @view='share'
              :show-download='false'
              :show-stats='false'
              :show-share='false'
              :post='post'
              :type='post.type'
              />
  </div>

          <!--
          <p class="text-center mb-2">Comments</p>
          -->
</template>
<script>
import MainBar from '@ui/organisms/MainBar.vue';
import CommentMultipleOutline from '@icons/CommentMultipleOutline.vue';
import Post from '@icons/Post.vue';
import User from '@ui/atoms/User.vue';
import VoteOnPost from '@ui/molecules/VoteOnPost.vue';
import EventEmitter from 'eventemitter3';
export default {
  inject: ['api'],
  props: {
    id: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    image: {
      type: String,
      required: true
    },
    aspect: {
      type: String,
      default: 'unknown'
    },
    user: {
      type: Object,
      required: true
    },
    upvotes: {
      type: Number,
      required: true
    },
    downvotes: {
      type: Number,
      required: true
    },
    parent: {
      type: Object,
      default() {
        return {
          id: 'root'
        }
      }
    },
    post:{
      type:Object,
      default() {
        return {}
      }
    },
    replies:{
      type:Object,
      default() {
        return {
          total: 0
        }
      }
    }
  },
  mounted() {
  },
  components: {
    //Post,
    User,
    MainBar,
    //CommentMultipleOutline,
    //VoteOnPost
  },
  methods:{
    onRemix() {
      this.$router.replace({
        hash:'#p' + this.id,
        query:{
          type:this.$route.query.type
        }
      });
      this.$router.push({
        name:'start',
        params:{
          parentId:'root',
          type:'post',
          __autoRemixImage: this.image,
          __autoselect: true
        }
      });
      this.$ana.track({
        eventCategory:'nav',
        eventAction:"layout",
        extra:{
          post:this.id,
          type:"image"
        }
      });
    },
    onAdd() {
      this.edit("add");
    },
    onBackground() {
      this.edit("background");
    },
    onStickers() {
      this.edit("stickers");
    },
    onText() {
      this.edit("text");
    },

    edit(mode) {
      this.$router.replace({
        hash:'#p' + this.id,
        query:{
          type:this.$route.query.type
        }
      });

      this.$router.push({
        name:'start',
        params:{
          parentId:this.id,
          type:'post',
        },
        query:{
          'mode':mode,
          'overlay':true
        }
      });
      this.$ana.track({
        eventCategory:'nav',
        eventAction:mode,
        extra:{
          post:this.id,
          type:"image"
        }
      });
    },
    share() {
      this.$router.push({
        name:'play',
        params:{
          id:this.id
        }
      });
    },
  },
  computed: {
    imageUrl() {
      return this.api.makeImageUrlEditor(this.image);
    }
  }
}
</script>

<style scoped>

.text--postShadow {
  @apply shadow-lg;
}

</style>
